import React, { useState } from "react";
import { orderhistory_api, track } from "../../api/urls";
import moment from "moment";
import { Box } from "@mui/material";

import { Dialog } from "@mui/material";
import Review from "./Review";
import useFetch from "../../hooks/useFetch";
import { PencilIcon, PhoneIcon } from "lucide-react";
import CancelSteps from "./CancelSteps";
import ReturnSteps from "./ReturnSteps";
import ReplaceSteps from "./ReplaceSteps";
import PriceBreakup from "./PriceBreakup";
// import { styled } from "@mui/material/styles";
// import StepConnector, {
//   stepConnectorClasses,
// } from "@mui/material/StepConnector";
import Loading from "../../components/Loading";
import { useNavigate } from "react-router-dom";
// import { useNavigate } from "react-router-dom";

const OrderStatus = ({ orderID, refetch, setOpenOrder }) => {
  const navigate = useNavigate();
  const { data: orderData, loading: orderLoading } = useFetch(
    orderID && orderhistory_api + `${orderID}/`,
  );
  // console.log("ORDER DATA:", orderData);

  // const [trackingData, setTrackingData] = useState(null);
  // const [loading, setLoading] = useState(false);
  const [isCancel, setIsCancel] = useState(false);
  const [isReturn, setIsReturn] = useState(false);
  const [isReplace, setIsReplace] = useState(false);
  const [openReview, setOpenReview] = useState(false);

  const { data, loading } = useFetch(orderID && `${track}${orderID}/`);
  const trackingData = data?.data;
  if (loading || orderLoading) return <Loading />;
  //  const navigate= useNavigate()
  const isDelivered =
    trackingData &&
    trackingData?.some((step) => step.status?.toLowerCase() === "delivered");

  if (isCancel)
    return (
      <CancelSteps
        setIsCancel={setIsCancel}
        orderID={orderID}
        orderData={orderData}
        refetch={refetch}
        setOpenOrder={setOpenOrder}
      />
    );

  if (isReturn) {
    return (
      <ReturnSteps
        setIsReturn={setIsReturn}
        orderID={orderID}
        orderData={orderData}
        refetch={refetch}
        setOpenOrder={setOpenOrder}
      />
    );
  }

  if (isReplace) {
    return (
      <ReplaceSteps
        setIsReplace={setIsReplace}
        orderID={orderID}
        orderData={orderData}
        refetch={refetch}
        setOpenOrder={setOpenOrder}
      />
    );
  }
  return (
    <div className="bg-[#F8FAFC] p-5">
      <div className="mx-auto flex md:flex-row flex-col md:max-w-[80vw] gap-5">
        <div className="flex-1">
          <div className="md:text-2xl mb-5">
            <span className="text-slate-500">Order ID:</span> #
            {orderData?.order_id}
          </div>
          {/* <div className="max-w-5xl"> */}{" "}
          <div
            className={
              "flex mb-4 flex-wrap p-3 bg-white rounded-xl border gap-4 md:justify-start justify-center"
            }
          >
            <div className="flex justify-between w-full text-slate-500 text-sm">
              {isDelivered && (
                <>
                  <button
                    className="cursor-pointer px-4 py-1 rounded-lg hover:bg-slate-100  transition-all flex gap-2 items-center"
                    onClick={() => setOpenReview(true)} // open the popup instead of navigating
                  >
                    <PencilIcon size={14} /> Write a Review
                  </button>

                  <Dialog
                    open={openReview}
                    onClose={() => setOpenReview(false)}
                    fullWidth
                    maxWidth="md"
                  >
                    <Review
                      product={{
                        id: orderData?.id,
                        product: orderData?.product,
                        orderId: orderData?.order_id,
                        orderDate: orderData?.updated,
                        title: orderData?.product_title,
                        image: orderData?.tagon_product_image,
                        color: orderData?.color,
                        quantity: orderData?.quantity,
                        payment: orderData?.total_amount_paid_amt,
                        soldBy: orderData?.company_name || "N/A",
                      }}
                      onClose={() => setOpenReview(false)} // allow the Cancel button to close the popup
                    />
                  </Dialog>
                </>
              )}
              {moment(orderData?.created).format("DD MMMM YYYY")}
            </div>
            <div
              className="rounded-xl h-[200px] w-[200px] overflow-hidden flex items-center justify-center cursor-pointer"
              onClick={() => navigate(`/products/${orderData?.product}`)}
            >
              <img
                src={orderData?.tagon_product_image}
                alt="Product"
                className="h-full w-full object-cover"
              />
            </div>
            <div>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <h1 className="font-medium capitalize text-xl">
                  {orderData?.product_title}
                </h1>
                <p className="text-2xl">₹{orderData?.product_sell_price_amt}</p>

                <div className="flex items-center gap-3">
                  {orderData?.color && (
                    <p>
                      <span className="text-slate-500">Color:</span>{" "}
                      {orderData?.color}
                    </p>
                  )}
                  <p>
                    <span className="text-slate-500">Quantity:</span>{" "}
                    {orderData?.quantity}
                  </p>
                  {orderData?.size && (
                    <p>
                      <span className="text-slate-500">Size:</span>{" "}
                      {orderData?.size}
                    </p>
                  )}
                </div>

                <div className="flex gap-3">
                  {orderData?.cancel_flag && (
                    <button
                      className="border cursor-pointer px-4 py-1 rounded-lg hover:bg-black hover:text-white transition-all"
                      onClick={() => setIsCancel(true)}
                    >
                      Cancel
                    </button>
                  )}
                  {orderData?.return_flag && (
                    <button
                      variant="outlined"
                      className="border cursor-pointer px-4 py-1 rounded-lg hover:bg-black hover:text-white transition-all"
                      onClick={() => setIsReturn(true)}
                    >
                      Return
                    </button>
                  )}
                  {orderData?.replace_flag && (
                    <button
                      className="border cursor-pointer px-4 py-1 rounded-lg hover:bg-black hover:text-white transition-all"
                      onClick={() => setIsReplace(true)}
                    >
                      Replace
                    </button>
                  )}
                </div>
              </Box>
            </div>
          </div>
          <Box className={"flex lg:flex-row flex-col gap-5"}>
            <OrderAddress
              addressType={"Shipping Address"}
              data={orderData?.shipping_address}
            />
            <OrderAddress
              addressType={"Billing Address"}
              data={orderData?.billing_address}
            />
          </Box>
          {/* </div> */}
        </div>
        <PriceBreakup data={orderData} />
      </div>

      <div className="mx-auto flex md:flex-row flex-col md:max-w-[80vw] gap-5 mt-5">
        <ShipmentTimeline data={trackingData} />
      </div>
    </div>
  );
};

const OrderAddress = ({ addressType, data }) => {
  return (
    <div className={"border rounded-lg flex-1 bg-white"}>
      <h3 className="mb-3 font-semibold border-b p-2 px-4">{addressType}</h3>
      <div className="pt-0 p-4">
        <h1 className="font-medium">{data?.name}</h1>

        <p className="text-slate-500">{`${data?.address}, ${data?.city} - ${data?.pincode}, ${data?.state}, ${data?.country}.`}</p>

        <div className="mt-3 flex gap-2">
          <span className="text-slate-500 pe-2"> Customer Contact:</span>
          <div className="space-y-2">
            {data?.primary_mobile && (
              <p className="flex items-center gap-1">
                <PhoneIcon size={15} /> +{data?.primary_mobile}
              </p>
            )}
            {data?.alternate_mobile && (
              <p className="flex items-center gap-1">
                <PhoneIcon size={15} /> +
                {data?.alternate_mobile || "979575657633"}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
const STATUS_TEXT = {
  "Order Confirmed": "Order information received by seller",
  "ORDER PROCESSED": "Seller is preparing to ship your order",
  Shipped: "Shipment information received by carrier",
  delivered: "Delivered to customer",
  "Return Requested": "Customer requested return",
  "APPROVAL PENDING": "Waiting for approval",
  Returned: "Item returned",
  Refunded: "Refund issued",
};
const ShipmentTimeline = ({ data }) => {
  if (!data?.length) return null;

  // sort by created_at (oldest first)
  const timeline = [...data].sort(
    (a, b) => new Date(a.created_at) - new Date(b.created_at),
  );

  return (
    <div className="w-full overflow-x-auto bg-white rounded-xl border p-3">
      <h2 className="text-lg font-semibold mb-6 px-3">Track Order</h2>

      <div className="flex items-start gap-10 relative min-w-max">
        {timeline.map((item, idx) => {
          const isLast = idx === timeline.length - 1;

          return (
            <div key={item.id} className="relative flex flex-col items-center">
              {/* Horizontal line */}

              {/* Marker */}
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center border-2 z-10
                ${
                  item.status
                    ? "bg-green-50 border-green-500 text-green-600"
                    : ""
                }
                `}
              >
                ✓
              </div>
              {!isLast && (
                <div className="absolute top-4 left-8 w-60 h-0.5 bg-gray-200" />
              )}
              {/* Content */}
              <div className="mt-4 text-center w-40">
                <p className="font-semibold uppercase text-sm">{item.status}</p>

                <p className="text-xs text-gray-600 mt-1">
                  {STATUS_TEXT[item.status] || ""}
                </p>

                <p className="text-xs text-gray-500 mt-1">{item.created_at}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OrderStatus;
